export default {
  section_title: 'Skattehåndtering',
  inherited_from_partner: 'Arvet',
  inherited_from_region: 'Regional standard',
  reset: 'Nulstil til arvet',
  form: {
    tax_name: {
      label: 'Skattenavn',
      tooltip: 'Hvordan skat navngives på kvitteringer og fakturaer, f.eks. moms eller GST.',
    },
    tax_behaviour: {
      label: 'Skattehåndtering',
      tooltip: 'Om dine menupriser allerede inkluderer moms, eller om moms lægges oveni ved betaling.',
      options: {
        inclusive: 'Inkluderet i menupriser',
        exclusive: 'Tillægges ved betaling',
      },
    },
    delivery_fee_tax_percentage: {
      label: 'Momssats for leveringsgebyr',
      tooltip: 'Den sats, som dit eget leveringsgebyr beskattes med, og som kan afvige fra satsen på maden.',
    },
  },
  impact: {
    title: 'Ændre skattehåndtering for dine restauranter?',
    affected_one: '{{count}} restaurant følger din standard og vil blive ændret.',
    affected_other: '{{count}} restauranter følger din standard og vil blive ændret.',
    overriding_one: '{{count}} restaurant har sin egen indstilling og beholder den.',
    overriding_other: '{{count}} restauranter har deres egen indstilling og beholder den.',
    confirm: 'Ændr dem',
  },
  buttons: {
    save: 'Gem',
    cancel: 'Annuller',
  },
  toasts: {
    load_error: 'Skatteindstillingerne kunne ikke indlæses',
    impact_error: 'Det kunne ikke kontrolleres, hvilke restauranter dette ville ændre',
    impact_changed_one: 'Antallet af berørte restauranter er ændret til {{count}}. Gennemgå og gem igen.',
    impact_changed_other: 'Antallet af berørte restauranter er ændret til {{count}}. Gennemgå og gem igen.',
    failed_to_save_changes: 'Ændringerne kunne ikke gemmes',
    changes_got_saved: 'Ændringerne er gemt',
  },
};
